import { BASE_API } from "../utils/constants";

export async function getProductsApi(onlyActive = false) {
  try {
    const activeFilter = onlyActive ? "?active=true" : "";
    const url = `${BASE_API}/api/products/${activeFilter}`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addProductApi(data, token) {
  try {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description || "");
    formData.append("price", data.price);
    if (data.estimatedCost !== "" && data.estimatedCost !== undefined) {
      formData.append("estimated_cost", data.estimatedCost);
    }
    formData.append("category", data.category);
    formData.append("order", data.order ?? 0);
    formData.append("active", data.active);
    formData.append("option_label", data.optionLabel || "");
    formData.append("option_choices", data.optionChoices || "");
    formData.append("option_required", data.optionRequired ? "true" : "false");
    formData.append("option_choice_count", data.optionChoiceCount || 1);
    (data.extraGroups || []).forEach((groupId) =>
      formData.append("extra_groups", groupId)
    );
    if (data.image) formData.append("image", data.image);

    const url = `${BASE_API}/api/products/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updateProductApi(id, data, token) {
  try {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description || "");
    formData.append("price", data.price);
    if (data.estimatedCost !== "" && data.estimatedCost !== undefined) {
      formData.append("estimated_cost", data.estimatedCost);
    }
    formData.append("category", data.category);
    formData.append("order", data.order ?? 0);
    formData.append("active", data.active);
    formData.append("option_label", data.optionLabel || "");
    formData.append("option_choices", data.optionChoices || "");
    formData.append("option_required", data.optionRequired ? "true" : "false");
    formData.append("option_choice_count", data.optionChoiceCount || 1);
    (data.extraGroups || []).forEach((groupId) =>
      formData.append("extra_groups", groupId)
    );
    if (data.image) formData.append("image", data.image);
    else if (data.removeImage) formData.append("image", "");

    const url = `${BASE_API}/api/products/${id}/`;
    const params = {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function deleteProductApi(id, token) {
  try {
    const url = `${BASE_API}/api/products/${id}/`;
    const params = {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getProductByIdApi(id) {
  try {
    const url = `${BASE_API}/api/products/${id}/`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getProductsByCategoryApi(idCategory, onlyActive = false) {
  try {
    const categoryFilter = `category=${idCategory}`;
    const activeFilter = onlyActive ? "&active=true" : "";
    const url = `${BASE_API}/api/products/?${categoryFilter}${activeFilter}`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
